import { ColorPalette } from "../../../config/colors"
import { ScrollView } from "@cantonjs/react-scroll-view"
import React, { Component } from "react"
import SimplePagination from "../Pagination/SimplePagination"
import { ChangeLog } from "../../../types"

interface ITimelineProps {
  logs: any[]
  shouldPaginate?: boolean
  key?: string
  isFirstPage?: boolean
  isLastPage?: boolean
  loadPrevious?: () => void
  loadNext?: () => void
  containerStyle?: React.CSSProperties | undefined
}

interface ITimelineState {
  warnings: any
  maxItemsPerRow: number
}

class Timeline extends Component<ITimelineProps, ITimelineState> {
  state = {
    warnings: {},
    maxItemsPerRow: 2,
  }

  private loadNext() {
    if (typeof this.props.loadNext === "undefined") {
      return
    }
    this.props.loadNext()
  }

  private loadPrevious() {
    if (typeof this.props.loadPrevious === "undefined") {
      return
    }
    this.props.loadPrevious()
  }

  render() {
    const {
      logs,
      shouldPaginate,
      isFirstPage,
      isLastPage,
      containerStyle,
      key,
      loadPrevious = () => {},
      loadNext = () => {},
    } = this.props

    let timelineBlocks: any = (
      <div style={{ ...styles.promptContainer }}>
        <p style={{ ...styles.text, color: ColorPalette.DARK_MEDIUM_GREY }}>No logs to show</p>
      </div>
    )

    let paginationController = null
    const hasLogs = logs && logs.length > 0
    if (hasLogs) {
      timelineBlocks = logs
      if (shouldPaginate) {
        paginationController = (
          <SimplePagination
            style={{ marginTop: 20 }}
            previousLabel={"PREVIOUS"}
            nextLabel={"NEXT"}
            key={key}
            isPrevious={!isFirstPage}
            isNext={!isLastPage}
            loadPrevious={() => loadPrevious()}
            loadNext={() => loadNext()}
          />
        )
      }
    }

    return (
      <ScrollView
        style={{ ...styles.container, ...containerStyle }}
        contentContainerStyle={{ ...styles.timelineStyle }}>
        {timelineBlocks}
        {paginationController}
      </ScrollView>
    )
  }
}

const styles = {
  container: {
    width: "100%",
    height: window.innerHeight * 0.75,
  },
  timelineStyle: {
    paddingTop: 10,
    paddingBottom: 100,
    display: "flex",
    flexDirection: "column" as "column",
    alignItems: "center",
  },
  promptContainer: {
    marginTop: window.innerHeight * 0.3,
    width: "100%",
    height: "78%",
    alignItems: "center",
    textAlign: "center" as "center",
    shadowOpacity: 0.16,
    shadowRadius: 4,
    shadowOffset: {
      width: 0,
      height: 6,
    },
  },
  text: {
    color: ColorPalette.PRIMARY_LIGHT_TEXT,
    fontFamily: "Roboto",
    fontWeight: "normal",
    fontSize: 15,
  },
}

export default Timeline
